module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Slider"
  }, [_c('transition-group', {
    attrs: {
      "name": "Slider-arrows-"
    }
  }, [(_vm.showPreviousArrow) ? _c('div', {
    key: "sliderArrowPrevious",
    staticClass: "Slider-arrowPrevious",
    on: {
      "click": _vm.previous
    }
  }, [_c('icon', {
    attrs: {
      "name": "arrow-left",
      "width": "12.41px",
      "height": "20.578px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showNextArrow) ? _c('div', {
    key: "sliderArrowNext",
    staticClass: "Slider-arrowNext",
    on: {
      "click": _vm.next
    }
  }, [_c('icon', {
    attrs: {
      "name": "arrow-right",
      "width": "12.41px",
      "height": "20.578px"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.items.length > 1) ? _c('div', {
    staticClass: "Slider-dots"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "Slider-dot",
      class: {
        'Slider-dot--isSelected': index === _vm.selectedIndex
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('carousel', {
    ref: "carousel",
    staticClass: "Slider-carousel",
    attrs: {
      "initial-index": _vm.initialIndex,
      "next": _vm.goNext,
      "prev": _vm.goPrev,
      "restart": _vm.goRestart
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      ref: "items",
      refInFor: true,
      staticClass: "Slider-item"
    }, [(item.template && item.template !== 'video') ? _c('div', {
      staticClass: "Slider-itemContent"
    }, [_c('div', {
      staticClass: "Slider-template"
    }, [_c(("slider-" + (item.template || 'text')), {
      tag: "component",
      attrs: {
        "content": item.content
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (item.template === 'video') ? _c('slider-video', {
      attrs: {
        "selected": index === _vm.selectedIndex,
        "url": item.video
      }
    }) : _vm._e()], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "Slider-images"
  }, [_c('div', {
    staticClass: "Slider-imagesGradient"
  }), _vm._v(" "), _vm._l((_vm.images), function(image, index) {
    return _c('div', {
      ref: "images",
      refInFor: true,
      staticClass: "Slider-image",
      style: (_vm.imageStyle(image, index))
    })
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c4db9b6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider/Slider.vue
// module id = 420
// module chunks = 1